import ArticleTemplate from '@/components/feature/ArticleTemplate';
import { allArticles } from '@/mocks/articles';

const article = allArticles.find((a) => a.slug === 'vigorbuy-spreadsheet-benefits')!;

export default function ArticleBenefitsPage() {
  return <ArticleTemplate article={article} />;
}